export type LegendLayer = "biz" | "idea" | "matter";

export type LegendVisualStyle = "solid" | "dashed";

export type LegendSource = "fallback" | "db";

export type LegendLinkKind =
  | "feishu_wiki"
  | "feishu_drive"
  | "feishu_doc"
  | "public_url"
  | "ops_path"
  | "x_account";

export const LEGEND_LINK_KINDS: LegendLinkKind[] = [
  "feishu_wiki",
  "feishu_drive",
  "feishu_doc",
  "public_url",
  "ops_path",
  "x_account",
];

export type BoardLegendLink = {
  kind: string;
  label: string;
  url: string;
  token?: string;
};

export type BoardLegendItem = {
  id?: number;
  token: string;
  layer: LegendLayer;
  line_key: string;
  label: string;
  description: string | null;
  sort_order: number;
  show_in_legend: boolean;
  visual_style: LegendVisualStyle;
  bar_hex: string | null;
  bar_text_hex: string | null;
  outline_hex: string | null;
  outline_text_hex: string | null;
  soft_dot_hex: string | null;
  soft_chip_bg: string | null;
  soft_chip_text: string | null;
  links: BoardLegendLink[];
  mac_account_path: string | null;
  active: boolean;
  source: LegendSource;
};

export type BoardLegendPatch = {
  label: string;
  description: string | null;
  visual_style: LegendVisualStyle;
  sort_order: number;
  show_in_legend: boolean;
  bar_hex: string | null;
  bar_text_hex: string | null;
  outline_hex: string | null;
  outline_text_hex: string | null;
  soft_dot_hex: string | null;
  soft_chip_bg: string | null;
  soft_chip_text: string | null;
  links: BoardLegendLink[];
  mac_account_path: string | null;
};
